import './Header.css'

function Header() {

    return (
        <div className="Header">
            <div id="header-inner">
                <img id="logo-infinit" src={ process.env.PUBLIC_URL + '/imgs/infinit.svg' } alt="Infinitcom" />
                <img id="logo-claro" src={ process.env.PUBLIC_URL + '/imgs/logo.svg' } alt="Claro agente oficial" />
            </div>
        </div>
    );
}

export default Header;